export { slideRevealAnimation } from './slideReveal.animation';
